import { render, staticRenderFns } from "./iconFont.vue?vue&type=template&id=2386432c&"
import script from "./iconFont.vue?vue&type=script&lang=js&"
export * from "./iconFont.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports